/* eslint-disable @typescript-eslint/naming-convention */
export enum ESurveysMutationType {
	SET_SURVEYS_LIST = 'setSurveysList',
	SET_SURVEY = 'setSurvey',
}
